export default function navigation() {

    $('.hamburger').click(function () {
        $(this).toggleClass('active');
        $('.header-navigation').toggleClass('open');
    });

    /*White line under header*/
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 5) {
            $('.header').addClass('line');
        } else {
            $('.header').removeClass('line');
        }
    });

}


// WEBPACK FOOTER //
// ./scripts/modules/navigation.js